export default {
  layout: {
    backToHome: '返回首頁',
    legalDocuments: '法律文件',
    product: '產品',
    developers: '開發者',
    company: '公司',
    legal: '法律',
  },
  nav: {
    markets: '市場',
    aiAgents: 'AI 代理',
    vaults: '金庫',
    leaderboard: '排行榜',
    fees: '費率',
    apiReference: 'API 參考',
    sdks: 'SDK',
    about: '關於 ZhiSu',
    careers: '徵才',
    contact: '聯絡我們',
    press: '媒體與新聞',
    brand: '品牌規範',
    terms: '服務條款',
    privacy: '隱私政策',
    cookies: 'Cookie 政策',
    aml: '反洗錢政策',
    risk: '風險揭露',
    agreement: '用戶協議',
    skills: '技能',
  },
  table: {
    pair: '交易對',
    price: '價格',
    change24h: '24h 漲跌',
    volume24h: '24h 成交量',
    funding: '資金費率',
    high24h: '24h 最高',
    low24h: '24h 最低',
    rank: '排名',
    trader: '交易者',
    pnl30d: '30天損益',
    winRate: '勝率',
    method: '方法',
    endpoint: '端點',
    description: '說明',
    auth: '驗證',
    required: '需要',
    none: '無',
    trades: '交易次數',
    volume: '交易量',
    followers: '追隨者',
  },
  common: {
    lastUpdated: '最後更新',
  },
  markets: {
    title: '市場',
    subtitle: '在 50 多種加密貨幣交易對上交易永續合約，最高 50 倍槓桿',
  },
  aiAgents: {
    title: 'AI 代理',
    subtitle: '部署具備機器學習策略的自主 AI 交易代理',
    pnl30d: '30天損益',
    winRate: '勝率',
    trades24h: '24h 交易次數',
    risk: '風險',
    avgHold: '平均持有',
  },
  vaults: {
    title: '金庫',
    subtitle: '具備內建風險管理的自動化收益策略金庫',
    tvl: '總鎖倉價值',
    apy: '年化報酬率',
    depositors: '存款人數',
    minDeposit: '最低存款',
    riskLevel: '風險等級',
    low: '低',
    medium: '中',
    high: '高',
  },
  leaderboard: {
    title: '排行榜',
    subtitle: '依 30 天損益排名的頂尖交易者',
    allTime: '歷史總計',
    weekly: '本週',
  },
  fees: {
    title: '費率',
    subtitle: '對所有交易者透明且具競爭力的費率結構',
    tier: '等級',
    maker: '掛單',
    taker: '吃單',
    volume30d: '30天交易量',
    holderRequirement: 'HOLDER 持有要求',
    fundingRate: '資金費率',
    fundingLong: '多頭支付空頭（當費率為正時）',
    fundingShort: '空頭支付多頭（當費率為負時）',
    withdrawalFees: '提領費用',
    asset: '資產',
    networkFee: '網路費用',
    minWithdrawal: '最低提領',
    perpetualTrading: '永續合約交易',
    interval: '間隔',
    settlement: '結算',
    maxRate: '最高費率',
  },
  apiReference: {
    title: 'API 參考',
    subtitle: '市場數據、交易與帳戶管理的完整 REST API 文件',
    baseUrl: '基礎網址',
    authentication: '驗證',
    authDesc: '公開端點無需驗證。需要驗證的端點需在 X-API-Key 標頭中傳入 API 金鑰。',
    rateLimits: '速率限制',
    public: '公開',
    authenticated: '已驗證',
    websocket: 'WebSocket',
    epMarkets: '列出所有可用的交易市場',
    epTicker: '取得特定市場的 24 小時行情數據',
    epOrderbook: '取得特定市場的訂單簿深度',
    epTrades: '取得特定市場的近期交易',
    epAccount: '取得帳戶餘額與持倉',
    epOrders: '下達新訂單',
    epCancelOrder: '取消現有訂單',
    epOrdersList: '列出活躍訂單',
    epFills: '取得歷史成交紀錄',
    epFundingRates: '取得所有市場的當前資金費率',
  },
  sdks: {
    title: 'SDK',
    subtitle: 'Python、TypeScript、Rust 與 Go 的官方 SDK',
    install: '安裝',
    documentation: '文件',
    pythonDesc: '功能完整的 Python REST API 與 WebSocket 串流客戶端。支援 async/await、型別提示與自動重連。',
    tsDesc: '現代化 TypeScript/JavaScript 客戶端，具備完整型別安全、內建重試邏輯與瀏覽器/Node.js 相容性。',
    rustDesc: '高效能 Rust 客戶端，針對低延遲交易機器人與量化策略優化。',
    goDesc: '輕量級 Go 客戶端，具備並行 WebSocket 支援與高效記憶體管理，適用於高頻應用。',
  },
  about: {
    title: '關於 ZhiSu',
    subtitle: '打造去中心化衍生品交易的未來',
    ourValues: '我們的價值觀',
    leadershipTeam: '領導團隊',
    backedBy: '投資方',
    decentralization: '去中心化',
    decentralizationDesc: '我們相信金融市場應在無中介的情況下運作。ZhiSu 上的每筆交易都在鏈上結算，讓用戶始終完全掌控自己的資產。',
    innovation: '創新',
    innovationDesc: '我們不斷突破 DeFi 的可能性。從 AI 驅動的交易代理到跨鏈流動性聚合，我們正在為下一代金融建構基礎設施。',
    transparency: '透明度',
    transparencyDesc: '所有協議運作、費用結構與治理決策均公開且可審計。我們的智慧合約已公開驗證，路線圖也與社群共享。',
    security: '安全性',
    securityDesc: '安全絕非事後考量。我們的程式碼經過多次獨立稽核，並設有完善的漏洞懸賞計畫以確保用戶資金安全。',
    founded: 'ZhiSu 成立於 2024 年，是建構於尖端區塊鏈基礎設施上的新一代去中心化衍生品交易所。',
    volume: '累積交易量超過 28 億美元，並擁有持續成長的 AI 驅動交易代理生態系，ZhiSu 已成為 DeFi 領域最值得信赖的平台之一。',
    teamDesc: '我們的團隊匯集了來自頂尖量化對沖基金、傳統金融機構與頂級區塊鏈協議的專業人才。',
    totalVolume: '總交易量',
    activeTraders: '活躍交易者',
    markets: '市場數量',
    countries: '服務國家',
    ceo: '執行長',
    cto: '技術長',
    headProduct: '產品負責人',
    headAI: 'AI 研究負責人',
    clo: '法務長',
    headEng: '工程負責人',
  },
  careers: {
    title: '徵才',
    subtitle: '加入打造 AI 原生交易基礎設施的團隊',
    openPositions: '職缺',
    allDepartments: '全部部門',
    engineering: '工程',
    product: '產品',
    design: '設計',
    marketing: '行銷',
    operations: '營運',
    legal: '法務',
    location: '地點',
    type: '類型',
    applyNow: '立即應徵',
    benefits: '為何加入 ZhiSu',
    benefit1Title: '具競爭力的薪酬',
    benefit1Desc: '高於市場的薪資、代幣配額與績效獎金。',
    benefit2Title: '遠端優先',
    benefit2Desc: '隨地辦公。我們是分布於全球的團隊。',
    benefit3Title: '尖端技術',
    benefit3Desc: '運用 AI、區塊鏈與分散式系統的最新技術進行開發。',
    benefit4Title: '快速成長',
    benefit4Desc: '在快速成長的產業中獲得快速的職涯發展。',
  },
  contact: {
    title: '聯絡我們',
    subtitle: '與我們的團隊取得聯繫',
    generalInquiries: '一般洽詢',
    support: '支援',
    press: '媒體',
    partnerships: '合作',
    sendMessage: '發送訊息',
    name: '姓名',
    email: '電子郵件',
    subject: '主旨',
    message: '訊息',
    followUs: '追蹤我們',
    response: '我們通常會在 24 小時內回覆。',
  },
  press: {
    title: '媒體與新聞',
    subtitle: 'ZhiSu 的最新消息與公告',
    mediaContact: '媒體聯絡',
    pressEmail: 'press@zhisu.trade',
    readMore: '閱讀更多',
  },
  brand: {
    title: '品牌規範',
    subtitle: '官方品牌素材與使用規範',
    logoUsage: '標誌使用',
    colorPalette: '配色方案',
    typography: '字體規範',
    do: '可以',
    dont: '不可以',
    primary: '主要色',
    secondary: '次要色',
    background: '背景色',
    accent: '強調色',
    headingFont: '標題字體',
    bodyFont: '內文字體',
    monoFont: '等寬字體',
    logoRules1: '在具有足夠對比度的深色或淺色背景上使用標誌。',
    logoRules2: '標誌周圍保持等於 V 標記高度的淨空間。',
    logoRules3: '針對不同背景使用提供的色彩變化版本。',
  },
  terms: {
    title: '服務條款',
    s1: '1. 服務條款接受',
    s2: '2. 資格',
    s3: '3. 服務說明',
    s4: '4. 帳戶註冊與安全',
    s5: '5. 交易規則與風險',
    s6: '6. 費用與收費',
    s7: '7. 禁止活動',
    s8: '8. 智慧財產權',
    s9: '9. 免責聲明',
    s10: '10. 責任限制',
    s11: '11. 賠償',
    s12: '12. 準據法與爭議解決',
    s13: '13. 條款修訂',
    s14: '14. 聯絡資訊',
  },
  privacy: {
    title: '隱私政策',
    s1: '1. 引言',
    s2: '2. 我們收集的資訊',
    s3: '3. 我們如何使用您的資訊',
    s4: '4. 處理的法律依據',
    s5: '5. 資訊分享與揭露',
    s6: '6. 資料安全',
    s7: '7. 資料保留',
    s8: '8. 您的權利',
    s9: '9. 國際資料傳輸',
    s10: '10. 兒童隱私',
    s11: '11. 政策變更',
    s12: '12. 聯絡我們',
  },
  cookies: {
    title: 'Cookie 政策',
    s1: '1. 什麼是 Cookie',
    s2: '2. 我們如何使用 Cookie',
    s3: '3. 我們使用的 Cookie 類型',
    s4: '4. 第三方 Cookie',
    s5: '5. 管理您的 Cookie 偏好',
    s6: '6. 網路信標與類似技術',
    s7: '7. 勿追蹤訊號',
    s8: '8. 政策變更',
    s9: '9. 聯絡我們',
  },
  aml: {
    title: '反洗錢政策',
    s1: '1. 政策聲明',
    s2: '2. 監管框架',
    s3: '3. 客戶盡職調查（CDD）',
    s4: '4. 持續監控',
    s5: '5. 禁止活動',
    s6: '6. 制裁合規',
    s7: '7. 可疑活動通報',
    s8: '8. 記錄保存',
    s9: '9. 員工培訓',
    s10: '10. 獨立稽核',
    s11: '11. 聯絡我們',
  },
  risk: {
    title: '風險揭露',
    s1: '1. 重要通知',
    s2: '2. 非財務建議',
    s3: '3. 市場風險',
    s4: '4. 槓桿與保證金風險',
    s5: '5. 智能合約與技術風險',
    s6: '6. AI 代理與自動交易風險',
    s7: '7. 託管與錢包風險',
    s8: '8. 監管與合規風險',
    s9: '9. 網路安全風險',
    s10: '10. 全額損失風險',
    s11: '11. 平台可用性不保證',
    s12: '12. 確認',
    s13: '13. 聯絡我們',
  },
  agreement: {
    title: '用戶協議',
    s1: '1. 協議概述',
    s2: '2. 定義',
    s3: '3. 帳戶與錢包連接',
    s4: '4. 交易規則',
    s5: '5. 費用與付款',
    s6: '6. AI 代理與自動化服務',
    s7: '7. API 使用',
    s8: '8. 聲明與保證',
    s9: '9. 終止',
    s10: '10. 爭議解決',
    s11: '11. 修改',
    s12: '12. 完整協議',
    s13: '13. 聯絡資訊',
  },
  skills: {
    title: '技能',
    subtitle: '發現並安裝社群構建的 AI 代理技能',
    searchPlaceholder: '你在找什麼？',
    install: '安裝',
    installNow: '安裝',
    categories: {
      all: '全部',
      defi: 'DeFi 與交易',
      social: '社交與訊息',
      tools: '分析與工具',
      other: '其他',
    },
    stats: {
      tools: '工具',
      users: '用戶',
      downloads: '下載',
      rating: '平均評分',
    },
    featuredSkills: '精選技能',
    trendingNow: '熱門趨勢',
    viewAll: '查看全部',
    allSkills: '所有技能',
    searchResults: '搜尋結果',
    noResults: '沒有找到符合條件的技能。',
    builtByCommunity: '由社群構建',
    equip: '裝備',
    unleash: '釋放',
    toolsReady: '數千開發者構建的工具，一鍵搜尋即可使用。',
    installCommand: '安裝命令',
    copied: '已複製！',
    copy: '複製',
    about: '關於',
    usageExample: '使用範例',
    info: '資訊',
    related: '相關技能',
    backToSkills: '返回技能',
    notFound: '找不到技能',
    notFoundDesc: '您要查找的技能不存在。',
  },
};